import { IUserApplication } from '@/typings';
import { adaptApplicationFormStatusResponseToApplicationStatus } from '../application';
import { UserApplicationItemResponseDTO } from '@/api/application/DTOs';
import { adaptGetSummaryResponseToAttestationSummary } from '../attestation';
import { adaptDecimalValueToPercentage } from '../utilities';

export const adaptUserApplicationsResponseToUserApplications = (
  userApplicationsResponse: UserApplicationItemResponseDTO[],
): IUserApplication[] => {
  return userApplicationsResponse.map(userApplicationResponse => ({
    id: userApplicationResponse.id,
    name: userApplicationResponse.name,
    clientName: userApplicationResponse.clientName,
    stateCode: userApplicationResponse.stateCode,
    started: userApplicationResponse.sectionsSummary.applicationStarted,
    sectionsCount:
      userApplicationResponse.sectionsSummary.applicationSectionsCount,
    sectionsCompleted:
      userApplicationResponse.sectionsSummary.applicationSectionsCompleted,
    requiredFieldsProgress: adaptDecimalValueToPercentage(
      userApplicationResponse.sectionsSummary.applicationCompletedPercentage,
    ),
    attestationSummary: adaptGetSummaryResponseToAttestationSummary(
      userApplicationResponse.attestationSummary,
    ),
    releaseCompletedDate: userApplicationResponse.releaseCompletedDate,
    signatureNameCompleted: userApplicationResponse.signatureNameCompleted,
    providerAuthorizedDate: userApplicationResponse.providerAuthorizedDate,
    providerReviewedDate: userApplicationResponse.providerReviewedDate,
    submittedToGeminiDate: userApplicationResponse.submittedToGeminiDate,
    verificationStartedDate: userApplicationResponse.verificationStartedDate,
    verifiedDate: userApplicationResponse.verifiedDate,
    status: adaptApplicationFormStatusResponseToApplicationStatus(
      userApplicationResponse.status,
    ),
    statusDescription: userApplicationResponse.statusDescription,
  }));
};
